import ImageView from '../../../../components/ui/ImageView/ImageView';
import { prizeList2goodsList } from '../../../../features/lottery/utils';
import fontsStyles from '../../../../styles/modules/fonts.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { LotteryDrawResultLineup, PrizeConvertedGoodsItem } from '../../types';
import styles from './RepostPrizeList.module.scss';

export type RepostPrizeListProps = {
  items: Array<LotteryDrawResultLineup>;
  onClickPrizeItem?: (goods: PrizeConvertedGoodsItem) => void;
};

function RepostPrizeList({ items, onClickPrizeItem }: RepostPrizeListProps) {
  const goodsList = prizeList2goodsList(items);
  const onClickItem = (goods: PrizeConvertedGoodsItem) => {
    if (!onClickPrizeItem) return;
    onClickPrizeItem(goods);
  };

  return (
    <ul className={styles.componentStyle}>
      {goodsList.map((goods) => (
        <li key={goods.id} onClick={() => onClickItem(goods)}>
          <div className={styles.itemLink}>
            <div className={styles.imageWrapper}>
              <div className={styles.itemImage}>
                <ImageView src={goods.imageUrl} />
              </div>
              <div className={styles.repostWrapper}>
                <span className={fontsStyles.montserrat}>リポストキャンペーン</span>
              </div>
            </div>
            <div className={`${styles.itemName} ${utilsStyles.textBold}`}>{goods.name}</div>
          </div>
        </li>
      ))}
      {/* ダミー */}
      {dummy()}
    </ul>
  );
}

function dummy() {
  const dummy = [];
  for (let i = 0; i < 4; i++) {
    dummy.push(<li key={`dummy_${i}`} />);
  }
  return dummy;
}

export default RepostPrizeList;
